import { Link } from '@mui/material';
import useStyles from './useStyles';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import translate from '../../../i18n/translate';
import { useState } from 'react';
import EventTransactionDataGrid from '../../Event/EventTransactionDataGrid';
import InProgressTransactionButton from '../../Unknown/InProgressTransactionButton';

const EventTransactionListScreen = () => {
  const classes = useStyles();
  const navigate = useNavigate()

  const { id, type } = useParams<{ id: string; type: string }>();
  const [searchParams] = useSearchParams();

  const [transactionType, setTransactionType] = useState<string>(type || 'all')

  const transactionTypes = [
    {
      key: 'all',
      title: translate('transactionAll')
    },
    {
      key: 'pending',
      title: translate('transactionPending')
    },
    {
      key: 'fast',
      title: translate('transactionFast')
    },
    {
      key: 'inProgress',
      title: translate('transactionInProgress')
    },
    {
      key: 'withdrawn',
      title: translate('transactionWithdrawn')
    },
    {
      key: 'rejected',
      title: translate('transactionRejected')
    },
    {
      key: 'cancelled',
      title: translate('transactionCancelled')
    },
  ];

  const handleTransactionTypeChange = (newType: string) => {
    setTransactionType(newType);

    navigate(`/events/${id}/transaction/list/${newType}`);
  }

  const transactionId = searchParams.get("transactionId")

  return(
      <div className={classes.Wrapper}>
        <div className={classes.StatusesList}>
          <Link 
            color="#fc7f03" 
            className={classes.ToMain} 
            mr={10} 
            ml="10px" 
            onClick={() => navigate("/events/all")}
          >
            {translate('commonBackToTheMainPage')}
          </Link>
          {transactionTypes.map((item, index)=>(
            <Link 
              key={index} 
              mr={2} 
              style={{
                cursor: "pointer",
                color: "#fc7f03",
                textDecorationColor: "#fc7f03",
                textDecoration: item.key === transactionType ? 'underline' : "none",
                fontSize: "20px",
              }} 
              onClick={() => handleTransactionTypeChange(item.key)}
            >
              {item.title}
            </Link>
          ))}
        <div/>
        <div className={classes.Panel}>
          <InProgressTransactionButton />
        </div>
      </div>
    <EventTransactionDataGrid type={transactionType} eventId={Number(id)} transactionId={transactionId ? Number(transactionId) : undefined} />
  </div>
  )
}

export default EventTransactionListScreen;